/**
 * AI Discover 工具函数
 */

// 粉丝数量范围标签对应的实际数值
// 索引: 0='0', 1='1K', 2='10K', 3='50K', 4='100K', 5='500K', 6='1M', 7='5M+'
const followerRangeValues = [0, 1000, 10000, 50000, 100000, 500000, 1000000, 5000000];

/**
 * 将粉丝范围索引转换为实际数值
 * @param index 范围索引 (0-7)
 * @returns 实际粉丝数
 */
export function convertFollowerIndexToValue(index: number): number {
  // 确保索引在有效范围内
  const validIndex = Math.max(0, Math.min(index, followerRangeValues.length - 1));
  return followerRangeValues[validIndex];
}

/**
 * 转换粉丝范围元组
 * @param range 范围索引元组 [startIndex, endIndex]
 * @returns 实际粉丝数范围 [startValue, endValue]
 */
export function convertFollowerRange(range: [number, number]): [number, number] {
  return [convertFollowerIndexToValue(range[0]), convertFollowerIndexToValue(range[1])];
}
